import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthModalService {
  /**
   * Opens the auth modal if the user is a guest.
   * Returns true if the modal was opened (guest), false if the user is already signed in.
   */
  public openIfGuest(popupType?: 'signedIn' | 'createAccount'): boolean {
    if (!window['AB']?.['COMMON']?.authorize()) {
      if (popupType === 'createAccount') {
        window['AB']?.['COMMON']?.openAuthenticateModal('createAccount');
      } else {
        window['AB']?.['COMMON']?.showSignInModal_OTP(window.location.href);
      }
      return true;
    }
    return false;
  }
}
